





































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mdbBtn, mdbIcon, mdbTooltip, mdbRow, mdbCol, mdbCard, mdbCardBody, mdbCardTitle, mdbView, mdbMask, mdbInput, mdbAlert, mdbTbl, mdbTblBody } from '@folky-tools/mdbvue';
import { usersService, businessSellingOptionsService, notificationsService } from '@/services';
import { UserActionLogInfo } from '@/models/users/user-logging/user-action-log-info';
import { UserActionType } from '@/models/users/user-logging/user-action-type';
import { UserActionEntityType } from '@/models/users/user-logging/user-action-entity-type';
import { UserActionScopeType } from '@/models/users/user-logging/user-action-scope-type';
import { BusinessSellingOptions } from '@/models/businesses/business-selling-options';

@Component({
    components: {
        mdbBtn,
        mdbIcon,
        mdbTooltip,
        mdbRow,
        mdbCol,
        mdbCard,
        mdbCardBody,
        mdbCardTitle,
        mdbTbl,
        mdbTblBody,
        mdbView,
        mdbMask,
        mdbInput,
        mdbAlert,
        FormModal: () => import('@/components/shared/FormModal.vue'),
        EditOrderingHours: () => import('@/components/shared/EditOrderingHours.vue')
    }
})
export default class BusinessProductSellingStatusSummary extends Vue {
    @Prop(BusinessSellingOptions) private businessSellingOptions!: BusinessSellingOptions;
    @Prop({ type: Boolean, default: false }) private hasBusinessTimeSensitiveReferences?: boolean;
    @Prop({ type: Boolean, default: false }) private pageContentLoaded?: boolean;
    private salesAdmissionHoursScheduleCopy: any = null;
    private showEditOrderingHours: boolean = false;
    private savingOrderingHours: boolean = false;

    private editBusinessOrderingHours(): void {
        this.salesAdmissionHoursScheduleCopy = JSON.parse(JSON.stringify(this.businessSellingOptions.salesAdmissionHoursSchedule));
        this.showEditOrderingHours = true;
    }

    private async saveBusinessOrderingHours(): Promise<void> {
        this.savingOrderingHours = true;

        try {
            if (await businessSellingOptionsService.updateSellingOptions(this.businessSellingOptions.businessId, this.businessSellingOptions)) {
                this.salesAdmissionHoursScheduleCopy = JSON.parse(JSON.stringify(this.businessSellingOptions.salesAdmissionHoursSchedule));
                this.closeBusinessOrderingHours();

                notificationsService.showToastSuccessNotification('components.businesses.businessProductOrderingHoursSummary.notifications.orderingHoursUpdated');

                await usersService.logUserAction(
                    new UserActionLogInfo({
                        type: UserActionType.HasChanged,
                        entity: UserActionEntityType.Businesses,
                        scope: UserActionScopeType.OrderingHours,
                        entityId: this.businessSellingOptions.businessId
                    })
                );

                return;
            }
            notificationsService.showToastErrorNotification();
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.savingOrderingHours = false;
        }
    }

    private closeBusinessOrderingHours(): void {
        this.businessSellingOptions.salesAdmissionHoursSchedule = JSON.parse(JSON.stringify(this.salesAdmissionHoursScheduleCopy));
        this.showEditOrderingHours = false;
    }
}
